import { useQuery } from "@tanstack/react-query";
import Table from "../../ChildComponents/Table";
import { MdEditDocument } from "react-icons/md";

import { useGetCategory } from "../../store/api/categoryApi";

function RoleList({ onEdit }) {
  const getCategory = useGetCategory();
  const {
    data: categoryData,
    isLoading: isRoleLoading,
    error: roleError,
  } = useQuery({ queryKey: ["category"], queryFn: getCategory });

  const data = categoryData?.categorys
    ?.map((category, index) => ({
      index: index + 1,
      name: category?.name,
      parentCategory: category?.parentCategory?.name,
      actionButton: (
        <>
          <button
            onClick={() => onEdit(category)}
            className="btn text-success mx-2"
          >
            <MdEditDocument />
          </button>
        </>
      ),
    }))
    .reverse();

  const columns = [
    {
      header: "SL#",
      accessor: "index",
    },
    {
      header: "Name",
      accessor: "name",
    },
    {
      header: "Parent Category",
      accessor: "parentCategory",
    },
    {
      header: "Actions",
      accessor: "actionButton",
    },
  ];
  return (
    <div>
      <Table columns={columns} data={data} isLoading={isRoleLoading} />
    </div>
  );
}

export default RoleList;
